<template>
  <div>
    <ApexChart
      height="319"
      type="line"
      :options="options"
      :series="series"
    />
  </div>
</template>

<script>
import ApexChart from "vue-apexcharts";

export default {
  components: {
    ApexChart,
  },
  props: {
    metrics: Array,
    dataFrom: String,
    graphOptions: Object,
  },
  data() {
    return {};
  },
  computed: {
    options() {
      let options = {...this.graphOptions};
      options.xaxis.categories = this.categories;
      options.yaxis.labels.formatter = function (value) {
        if (value === null) {
          return this.$t("heading.hosting.usage.graphs.noData");
        }
        return `${value} pps`;
      };
      options.legend = {
        show: false
      };
      return options;
    },
    series() {
      return [
        {
          name: this.$t("heading.hosting.usage.graphs.in"),
          data: this.dataIn,
        },
        {
          name: this.$t("heading.hosting.usage.graphs.out"),
          data: this.dataOut,
        },
      ];
    },
    dataIn() {
      if (this.metrics === null) {
        return [];
      }
      let data = [];
      for (let m of this.metrics) {
        data.push({
          x: m.period,
          y: Object.hasOwn(m, "net_in_pps") ? m.net_in_pps : null,
        });
      }
      return data;
    },
    dataOut() {
      if (this.metrics === null) {
        return [];
      }
      let data = [];
      for (let m of this.metrics) {
        data.push({
          x: m.period,
          y: Object.hasOwn(m, "net_out_pps") ? m.net_out_pps : null,
        });
      }
      return data;
    },
    categories() {
      let categories = [];
      for (let d of this.dataIn) {
        categories.push(d.x);
      }
      return categories;
    },
  },
};
</script>